import React from "react";
import PaypalReactivationForm from "../PaypalReactivationForm";
import FakePaypalButton from "./PaypalButton";

export default function (props) {
  return <PaypalReactivationForm {...props} PaypalButton={FakePaypalButton} />;
}
